import { LegacyBox, Breadcrumbs, Paper, styled } from '@gogame/components';

export const BreadcrumbsStyled = styled(Breadcrumbs)`
  font-size: 16px;
  line-height: normal;
  height: 64px;
  display: flex;
`;

export const PaperLevelsStyled = styled(Paper)`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 100%;
  flex: 1 1 auto;
  flex-direction: column;
`;

export const Header = styled(LegacyBox)`
  padding: 0 16px;
`;
